/* API functions for Datenimport (Data Import) */

function getBaseURL() {
  const ensureTrailingSlash = (u: string) => (u.endsWith('/') ? u : `${u}/`);
  const raw = (
    (import.meta as any).env?.VITE_API_BASE_URL ||
    (typeof window !== 'undefined' ? `${window.location.origin}/api` : '/api')
  );
  const base =
    raw.startsWith('http://') || raw.startsWith('https://')
      ? raw
      : typeof window !== 'undefined'
        ? `${window.location.origin}${raw.startsWith('/') ? '' : '/'}${raw}`
        : raw;
  return ensureTrailingSlash(base);
}

function getAccessToken(): string | null {
  try {
    return localStorage.getItem('accessToken');
  } catch {
    return null;
  }
}

export interface DatenimportResult {
  totalRows: number;
  kundenNeuAngelegt: number;
  patientenNeuAngelegt: number;
  patientenAktualisiert: number;
  materialienNeuAngelegt: number;
  herstellerNeuAngelegt: number;
  fehler: string[];
}

export async function uploadCsvImport(file: File): Promise<DatenimportResult> {
  const url = new URL('Datenimport/import', getBaseURL());
  const token = getAccessToken();
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const formData = new FormData();
  formData.append('file', file);

  const resp = await fetch(url.toString(), {
    method: 'POST',
    headers,
    body: formData,
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `Fehler beim Datenimport (HTTP ${resp.status})`);
  }

  return resp.json();
}
